export default {
  state: {
    holidayData: {},
  },

  getters: {
    getHolidayData(state) {
      return state.holidayData;
    },
  },

  mutations: {
    setHolidayData(state, data) {
      const isNull = data === null;

      state.holidayData = {
        id: !isNull ? data.id : "",
        created_at: !isNull ? data.created_at : "",
        deleted_at: !isNull ? data.deleted_at : "",
        end_date: !isNull ? data.end_date : "",
        holiday_type: !isNull ? data.holiday_type : "",
        polyclinic: !isNull ? data.polyclinic : {},
        polyclinic_id: !isNull ? +data.polyclinic_id : "",
        rn: !isNull ? data.rn : "",
        start_date: !isNull ? data.start_date : "",
        updated_at: !isNull ? data.updated_at : "",
        week_day_name: !isNull ? data.week_day_name : "",
        observation: !isNull ? data.observation : "",
      };
    },
  },

  actions: {
    changeHolidayData(context, infos) {
      context.commit("setHolidayData", infos);
    },
  },
};
